import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { planQueries } from '@/services/plans/queries';
import { planMutations } from '@/services/plans/mutations';



export const usePlans = (providerId: number, versionId: number) => {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ['plans', providerId, versionId],
    queryFn: async () => {
      const plans = await planQueries.getPlans(providerId, versionId);
      
      return plans;
    }
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    createPlan: useMutation({
      mutationFn: async (data: { name: string; color_index: number }) => {
        const { error } = await supabase
          .from('plans')
          .insert({
            ...data,
            provider_id: providerId,
            version_id: versionId
          });

        if (error) throw error;
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['plans'] });
      }
    }),
    removeChannels: useMutation({
      mutationFn: async ({ planId, channelIds }: { planId: number; channelIds: number[] }) => {
        await planMutations.removeChannels(planId, channelIds);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['plans', providerId, versionId] });
        queryClient.invalidateQueries({ queryKey: ['channels', providerId, versionId] });
      }
    }),
    // ... rest of the mutations
  };
};
